/**
 * @desc 批量审批
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.StorageDamagetWorkflowDto>, options?: any) {
  return updateResponse(
    http(URL + `/storageReportDamage/batchApproval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
